<bid-header></bid-header>
<router-outlet></router-outlet>
